import { EntityActions } from '~/apps/shared/actions/consts';

import * as api from '../apis/paycodes';
import { apiCall } from '~/lib/redux/api';
import { PaycodeActions } from './consts';
import { PaycodeNormalizer } from './normalize';
import { defaultTablePageSize } from '~/common/components/consts';


// TODO: Use constants
export function getPaycodeById(paycodeId: string) {
  return apiCall({
    actions: [
      PaycodeActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, PaycodeActions.LOAD_SUCCESS],
      PaycodeActions.LOAD_ERROR,
    ],
    normalizer: PaycodeNormalizer,
    fn: () => api.getPaycodeById(paycodeId),
  });
}

export function getOrgPaycodes(orgId: string, filter=null, offset=0, limit=defaultTablePageSize, hideInactive=false) {
  return apiCall({
    actions: [
      PaycodeActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, PaycodeActions.LOAD_LIST_SUCCESS],
      PaycodeActions.LOAD_ERROR,
    ],
    normalizer: [PaycodeNormalizer],
    fn: () => api.getOrgPaycodes(orgId, {
      filter,
      offset,
      limit,
      hideInactive,
    }),
  })
}

export function createPaycode(orgId: string, data) {
  return apiCall({
    actions: [
      PaycodeActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, PaycodeActions.LOAD_SUCCESS],
      PaycodeActions.LOAD_ERROR,
    ],
    normalizer: PaycodeNormalizer,
    fn: () => api.createPaycode(orgId, data),
  })
}

export function updatePaycode(paycodeId: string, data) {
  return apiCall({
    actions: [
      PaycodeActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, PaycodeActions.LOAD_SUCCESS],
      PaycodeActions.LOAD_ERROR,
    ],
    normalizer: PaycodeNormalizer,
    fn: () => api.updatePaycode(paycodeId, data),
  })
}

export function deletePaycode(paycodeId: string) {
  return apiCall({
    actions: [
      PaycodeActions.LOAD_REQUEST,
      PaycodeActions.LOAD_SUCCESS,
      PaycodeActions.LOAD_ERROR,
    ],
    normalizer: PaycodeNormalizer,
    fn: () => api.deletePaycode(paycodeId),
  })
}

export function setPaycodeCurrentPage(page: number) {
  return {
    type: PaycodeActions.SET_CURRENT_PAGE,
    currentPage: page,
  }
}
